<template>
	<div>
		<nav-bar-home></nav-bar-home>
		<main class="main">
			<section id="checkout" class="pr-main">
				<div class="container">
					<div class="cart-view-top">
						<div class="col-md-6 col-sm-6 col-xs-12">
							<h1>Checkout</h1>
						</div>
						<div class="col-md-6 col-sm-6 col-xs-12 right">
							<h1>Continue Shopping</h1>
						</div>
						<div id="login-pane" class="col-md-12 col-sm-12 col-xs-12">
							<p>Please fill in the fields below to complete your order.</p>
						</div>
					</div>
					<div class="onepage" v-if="user">
						<div class="col-md-4 col-sm-12 col-xs-12">
							<div v-if="!user.isSubChildUser" id="sub_customer_list">
								<div class="pane round-box">
									<h3 class="title">
										<span class="icon icon-one">1</span>
										{{ isAddressListMode ? 'Select Address' : 'MY CUSTOMER LIST' }} </h3>
											<div class="pane-inner">
												<!-- Customer Account Type 1: pick the client address by Business Name -->
												<div v-if="isAddressListMode" class="addr-picker"
													:class="{ 'is-loading': addressLoading }">
													<div v-if="addressOptions.length > 3" class="addr-search">
														<i class="fa fa-search" aria-hidden="true"></i>
														<input type="text" v-model="addressSearch"
															placeholder="Search business name or address">
													</div>
													<div class="addr-list" role="radiogroup" aria-label="Select address">
														<button type="button" v-for="opt in filteredAddressOptions"
															:key="opt.id" class="addr-card"
															:class="{ 'is-active': selectedCustomer === opt.id }"
															role="radio" :aria-checked="selectedCustomer === opt.id"
															:disabled="addressLoading" @click="selectAddress(opt.id)">
															<span class="addr-check" aria-hidden="true"></span>
															<span class="addr-body">
																<span class="addr-name">
																	<span class="addr-name-text"
																		:class="{ 'addr-name-missing': !opt.businessName }">
																		{{ opt.businessName || 'No business name' }}</span>
																	<span v-if="opt.id === 'default'" class="addr-badge">Default</span>
																</span>
																<span v-for="(line, i) in opt.lines" :key="i"
																	class="addr-line">{{ line }}</span>
															</span>
														</button>
														<p v-if="!filteredAddressOptions.length" class="addr-empty">
															No addresses match "{{ addressSearch }}"
														</p>
													</div>
												</div>
												<select v-else name="customer" id="customer" class="customer-list"
													v-model="selectedCustomer" @change="handleOptionChange">
													<option value="default">Default</option>
													<option v-for="subUser in subChildUser" :key="subUser._id"
														:value="subUser._id">{{ subUser.name }} {{ subUser.lastName
														}}</option>
												</select>
												<div v-if="shouldShowDiv && !isAddressListMode">
													<p>Switch to branch/location.</p>
													<div id="radio_wrapper" class="radio-btn">
														<p>
															<input type="radio" name="parent_user" value="yes"
																v-model="selectedOption" @change="handleRadioChange"
																checked />No
														</p>
														<p>
															<input type="radio" name="parent_user" value="no"
																v-model="selectedOption"
																@change="handleRadioChange" />Yes
														</p>
													</div>
												</div>
											</div>
								</div>
							</div>
							<!-- <div v-if="user.isSubChildUser" id="branch_list">
						 <div class="pane round-box" >
							 <h3 class="title"><span class="icon icon-one">1</span>Switch To Branch/Location</h3>
								 
								 <div class="pane-inner">
									 <div id="radio_wrapper" class="radio-btn">
										 <p>
										 <input type="radio" name="sub_child_no" value="yes" v-model="selectedOption" @change="handleRadioChange" checked />No
										 </p>
										 <p>
										 <input type="radio" name="sub_child_no" value="no" v-model="selectedOption" @change="handleRadioChange" />Yes
										 </p>
									 </div>
								 </div>
							</div>
									</div>	 -->
							<div id="div_billto">
								<div class="pane round-box" v-if="vbill">
									<h3 class="title"><span class="icon icon-one">{{ user.isSubChildUser ? 1 : 2
									}}</span>BILLING INFO</h3>
									<div
										v-if="(user.billing == null && user.billing == undefined) || (userAddresses.length === 1 || userAddresses.length == 0)">
										<div class="pane-inner"
											v-if="user.billing !== null && user.billing !== undefined">
											<div>
												<span style="display:inline-block;width:120px;">Business Name:</span>
												<span style="display:inline-block;width:120px;">{{ (selectedOption === 'no' && branchSwitchAddress) ? (branchSwitchAddress.billBusinessName || branchSwitchAddress.businessName || user.accountTitle) : ((user.billing && (user.billing.billBusinessName || user.billing.businessName)) || user.accountTitle) }}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Address Line 1:</span>
												<span style="display:inline-block;width:140px;"
													v-if="!user.isSubChildUser">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? branchSwitch.address.addressOne :
															(selectedparentOption === 'deiveryInfo' ?
																(user.billing.billAddressOne ? user.billing.billAddressOne : user.billing.addressOne) :
																(selectedparentOption === 'billInfo' ?
																	branchSwitch.address.addressOne : '')
															)
														)
														: (user.billing.billAddressOne ? user.billing.billAddressOne :
															user.billing.addressOne)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' ? (branchSwitch.billing.billAddressOne ? branchSwitch.billing.billAddressOne : branchSwitch.billing.addressOne) :
														(user.billing.billAddressOne ? user.billing.billAddressOne : user.billing.addressOne) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Address Line 2</span>
												<span style="display:inline-block;width:140px;"
													v-if="!user.isSubChildUser">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? branchSwitch.address.addressTwo :
															(selectedparentOption === 'deiveryInfo' ?
																(user.billing.billAddressTwo ? user.billing.billAddressTwo : user.billing.addressTwo) :
																(selectedparentOption === 'billInfo' ?
																	branchSwitch.address.addressTwo : '')
															)
														)
														: (user.billing.billAddressTwo ? user.billing.billAddressTwo :
															user.billing.addressTwo)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' ? (branchSwitch.billing.billAddressTwo ? branchSwitch.billing.billAddressTwo : branchSwitch.billing.addressTwo) :
														(user.billing.billAddressTwo ? user.billing.billAddressTwo : user.billing.addressTwo) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">City/Town:</span>
												<span style="display:inline-block;width:140px;"
													v-if="!user.isSubChildUser">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? branchSwitch.address.city :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billCity ? user.billing.billCity : user.billing.city) :
																(selectedparentOption === 'billInfo' ? branchSwitch.address.city :
																	'')
															)
														)
														: (user.billing.billCity ? user.billing.billCity :
															user.billing.city)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' ? (branchSwitch.billing.billCity ? branchSwitch.billing.billCity : branchSwitch.billing.city) :
														(user.billing.billCity ? user.billing.billCity : user.billing.city) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">County:</span>
												<span style="display:inline-block;width:140px;"
													v-if="!user.isSubChildUser">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? branchSwitch.address.county :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billCounty ? user.billing.billCounty : user.billing.county) :
																(selectedparentOption === 'billInfo' ? branchSwitch.address.county :
																	'')
															)
														)
														: (user.billing.billCounty ? user.billing.billCounty :
															user.billing.county)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' ? (branchSwitch.billing.billCounty ? branchSwitch.billing.billCounty : branchSwitch.billing.county) :
														(user.billing.billCounty ? user.billing.billCounty : user.billing.county) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Country:</span>
												<span style="display:inline-block;width:140px;"
													v-if="!user.isSubChildUser">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? branchSwitch.address.country :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billCountry ? user.billing.billCountry : user.billing.country) :
																(selectedparentOption === 'billInfo' ? branchSwitch.address.country
																	: '')
															)
														)
														: (user.billing.billCountry ? user.billing.billCountry :
															user.billing.country)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' ? (branchSwitch.billing.billCountry ? branchSwitch.billing.billCountry : branchSwitch.billing.country) :
														(user.billing.billCountry ? user.billing.billCountry : user.billing.country) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">PostCode:</span>
												<span style="display:inline-block;width:140px;"
													v-if="!user.isSubChildUser">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? branchSwitch.address.postCode :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billPostCode ? user.billing.billPostCode : user.billing.postCode)
																:
																(selectedparentOption === 'billInfo' ? branchSwitch.address.postCode
																	: '')
															)
														)
														: (user.billing.billPostCode ? user.billing.billPostCode :
															user.billing.postCode)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' ? (branchSwitch.billing.billPostCode ? branchSwitch.billing.billPostCode : branchSwitch.billing.postCode) :
														(user.billing.billPostCode ? user.billing.billPostCode : user.billing.postCode) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Mobile Number:</span>
												<span style="display:inline-block;width:140px;"
												v-if="!user.isSubChildUser">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? formatMobile(branchSwitch.address.mobileNumber) :
															(selectedparentOption === 'deiveryInfo' ? formatMobile(user.billing.billMobileNumber ? user.billing.billMobileNumber : user.billing.mobileNumber)
																:
																(selectedparentOption === 'billInfo' ? formatMobile(branchSwitch.address.mobileNumber)
																	: '')
															)
														)
														: formatMobile(user.billing.billMobileNumber ? user.billing.billMobileNumber :
															user.billing.mobileNumber)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' ? formatMobile(branchSwitch.billing.billMobileNumber ? branchSwitch.billing.billMobileNumber : branchSwitch.billing.mobileNumber) :
														formatMobile(user.billing.billMobileNumber ? user.billing.billMobileNumber : user.billing.mobileNumber) }}
												</span>
											</div>
											<p v-if="user.isUserType === 'dentalcare'"></p>
											<p v-else-if="user.isSubChildUser"></p>
											<p v-else>Want a diffrent Address, click <a class="text-danger"
													@click="resetBilling()">HERE</a> to set
												different </p>
										</div>
										<div class="pane-inner" v-else>
											<span class="text-danger"> Select Billing Address </span>
											<select name="" id="" class="form-control" v-model="slBilling">
												<option v-for="subUser in subChildUser" :key="subUser._id"
													:value="subUser._id">{{ subUser.name }}
													{{ subUser.lastName }}</option>
												<!-- <option v-for="add in userAddresses" :value="add" :key="add._id">
										{{ selectedOption === 'no' ? branchSwitch.billing.addressOne : add.addressOne }},
										{{ selectedOption === 'no' ? branchSwitch.billing.city : add.city }},
										{{ selectedOption === 'no' ? branchSwitch.billing.county : add.county }}
										</option> -->
											</select>
											<!-- <span class="text-danger"> No Billing address found, click <a href="/user-dashboard/addresses">HERE</a> to set one </span> -->
											<h3>OR</h3>
											<p>Provide Manually</p>
											<input type="text" name="" id="" v-model="newBilling.addressOne"
												placeholder="Address Line One" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.addressTwo"
												placeholder="Address Line Two" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.city"
												placeholder="City/Town" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.county"
												placeholder="County" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.country"
												placeholder="Country" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.postCode"
												placeholder="Post Code" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.mobileNumber" maxlength="11"
												@input="newBilling.mobileNumber = $event.target.value.replace(/[^0-9]/g, '').slice(0, 11)"
												placeholder="Mobile No" class="form-control">
											<button class="btn btn-success form-control" style="margin-bottom:15px;"
												@click="addBillingAddress">Add
												Billing Address</button>
										</div>
									</div>
									<div v-else>
										<div class="pane-inner"
											v-if="user.billing !== null && user.billing !== undefined">
											<div>
												<span style="display:inline-block;width:120px;">Business Name:</span>
												<span style="display:inline-block;width:120px;">{{ (selectedOption === 'no' && branchSwitchAddress) ? (branchSwitchAddress.billBusinessName || branchSwitchAddress.businessName || user.accountTitle) : ((user.billing && (user.billing.billBusinessName || user.billing.businessName)) || user.accountTitle) }}</span>
											</div>
											<div>												
												<span style="display:inline-block;width:120px;">Address Line 1:</span>
												<span style="display:inline-block;width:140px;"
													v-if="userAddresses.length > 1">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ?
															(branchSwitchAddress.billAddressOne ?
																branchSwitchAddress.billAddressOne : branchSwitchAddress.addressOne)
															:
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billAddressOne ? user.billing.billAddressOne : user.billing.addressOne) :
																(selectedparentOption === 'billInfo' ?
																	(branchSwitchAddress.billAddressOne ?
																		branchSwitchAddress.billAddressOne : branchSwitchAddress.addressOne)
																	: '')
															)
														)
														: (user.billing.billAddressOne ? user.billing.billAddressOne : user.billing.addressOne)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
														defaultBranchSwitchAddress.billing.billAddressOne :
														(user.billing.billAddressOne ? user.billing.billAddressOne : user.billing.addressOne) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Address Line 2</span>
												<span style="display:inline-block;width:140px;"
													v-if="userAddresses.length > 1">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ?
															(branchSwitchAddress.billAddressTwo ?
																branchSwitchAddress.billAddressTwo : branchSwitchAddress.addressTwo)
															:
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billAddressTwo ? user.billing.billAddressTwo : user.billing.addressTwo) :
																(selectedparentOption === 'billInfo' ?
																	(branchSwitchAddress.billAddressTwo ?
																		branchSwitchAddress.billAddressTwo : branchSwitchAddress.addressTwo)
																	: '')
															)
														)
														: (user.billing.billAddressTwo ? user.billing.billAddressTwo : user.billing.addressTwo)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
														defaultBranchSwitchAddress.billing.billAddressTwo :
														(user.billing.billAddressTwo ? user.billing.billAddressTwo : user.billing.addressTwo) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">City/Town:</span>
												<span style="display:inline-block;width:140px;"
													v-if="userAddresses.length > 1">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? (branchSwitchAddress.billCity ?
															branchSwitchAddress.billCity
															: branchSwitchAddress.city) :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billCity ? user.billing.billCity : user.billing.city) :
																(selectedparentOption === 'billInfo' ? (branchSwitchAddress.billCity
																	?
																	branchSwitchAddress.billCity : branchSwitchAddress.city) : '')
															)
														)
														: (user.billing.billCity ? user.billing.billCity : user.billing.city)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
														defaultBranchSwitchAddress.billing.billCity : (user.billing.billCity ? user.billing.billCity : user.billing.city) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">County:</span>
												<span style="display:inline-block;width:140px;"
													v-if="userAddresses.length > 1">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? (branchSwitchAddress.billCounty
															?
															branchSwitchAddress.billCounty : branchSwitchAddress.county) :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billCounty ? user.billing.billCounty : user.billing.county) :
																(selectedparentOption === 'billInfo' ?
																	(branchSwitchAddress.billCounty ?
																		branchSwitchAddress.billCounty : branchSwitchAddress.county) : '')
															)
														)
														: (user.billing.billCounty ? user.billing.billCounty : user.billing.county)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
														defaultBranchSwitchAddress.billing.billCounty : (user.billing.billCounty ? user.billing.billCounty : user.billing.county)
													}}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Country:</span>
												<span style="display:inline-block;width:140px;"
													v-if="userAddresses.length > 1">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? (branchSwitchAddress.billCountry ?
															branchSwitchAddress.billCountry : branchSwitchAddress.country) :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billCountry ? user.billing.billCountry : user.billing.country) :
																(selectedparentOption === 'billInfo' ?
																	(branchSwitchAddress.billCountry ?
																		branchSwitchAddress.billCountry : branchSwitchAddress.country) : '')
															)
														)
														: (user.billing.billCountry ? user.billing.billCountry : user.billing.country)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
														defaultBranchSwitchAddress.billing.billCountry : (user.billing.billCountry ? user.billing.billCountry : user.billing.country)
													}}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">PostCode:</span>
												<span style="display:inline-block;width:140px;"
													v-if="userAddresses.length > 1">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? (branchSwitchAddress.billPostCode
															?
															branchSwitchAddress.billPostCode : branchSwitchAddress.postCode) :
															(selectedparentOption === 'deiveryInfo' ? (user.billing.billPostCode ? user.billing.billPostCode : user.billing.postCode) :
																(selectedparentOption === 'billInfo' ?
																	(branchSwitchAddress.billPostCode ?
																		branchSwitchAddress.billPostCode : branchSwitchAddress.postCode) :
																	'')
															)
														)
														: (user.billing.billPostCode ? user.billing.billPostCode : user.billing.postCode)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
														defaultBranchSwitchAddress.billing.billPostCode :
														(user.billing.billPostCode ? user.billing.billPostCode : user.billing.postCode) }}
												</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Mobile Number:</span>
												<span style="display:inline-block;width:140px;"
													v-if="userAddresses.length > 1">
													{{ selectedOption === 'no' ?
														(selectedparentOption === 'both' ? formatMobile(branchSwitchAddress.billMobileNumber ? branchSwitchAddress.billMobileNumber : branchSwitchAddress.mobileNumber)
															:
															(selectedparentOption === 'deiveryInfo' ? formatMobile(user.billing.billMobileNumber ? user.billing.billMobileNumber : user.billing.mobileNumber)
																:
																(selectedparentOption === 'billInfo' ?
																	formatMobile(branchSwitchAddress.billMobileNumber ? branchSwitchAddress.billMobileNumber : branchSwitchAddress.mobileNumber) : '')
															)
														)
														: formatMobile(user.billing.billMobileNumber ? user.billing.billMobileNumber : user.billing.mobileNumber)
													}}
												</span>
												<span style="display:inline-block;width:140px;" v-else>
													{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
														formatMobile(defaultBranchSwitchAddress.billing.billMobileNumber ? defaultBranchSwitchAddress.billing.billMobileNumber : defaultBranchSwitchAddress.billing.mobileNumber) :
														formatMobile(user.billing.billMobileNumber ? user.billing.billMobileNumber : user.billing.mobileNumber) }}
												</span>
											</div>
											<p v-if="userAddresses.length > 1"></p>
											<p v-else-if="user.isSubChildUser"></p>
											<p v-else>Want a diffrent Address, click <a class="text-danger"
													@click="resetBilling()">HERE</a> to set
												different </p>
										</div>
										<div class="pane-inner" v-else>
											<span class="text-danger"> Select Billing Address </span>
											<select name="" id="" class="form-control" v-model="slBilling">
												<option v-for="subUser in subChildUser" :key="subUser._id"
													:value="subUser._id">{{ subUser.name }}
													{{ subUser.lastName }}</option>
												<!-- <option v-for="add in userAddresses" :value="add" :key="add._id">
										{{ selectedOption === 'no' ? branchSwitch.billing.addressOne : add.addressOne }},
										{{ selectedOption === 'no' ? branchSwitch.billing.city : add.city }},
										{{ selectedOption === 'no' ? branchSwitch.billing.county : add.county }}
										</option> -->
											</select>
											<!-- <span class="text-danger"> No Billing address found, click <a href="/user-dashboard/addresses">HERE</a> to set one </span> -->
											<h3>OR</h3>
											<p>Provide Manually</p>
											<input type="text" name="" id="" v-model="newBilling.addressOne"
												placeholder="Address Line One" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.addressTwo"
												placeholder="Address Line Two" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.city"
												placeholder="City/Town" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.county"
												placeholder="County" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.country"
												placeholder="Country" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.postCode"
												placeholder="Post Code" class="form-control">
											<input type="text" name="" id="" v-model="newBilling.mobileNumber" maxlength="11"
												@input="newBilling.mobileNumber = $event.target.value.replace(/[^0-9]/g, '').slice(0, 11)"
												placeholder="Mobile No" class="form-control">
											<button class="btn btn-success form-control" style="margin-bottom:15px;"
												@click="addBillingAddress">Add
												Billing Address</button>
										</div>
									</div>
								</div>
							</div>
							<div id="shipping_info_w" v-if="userCartItems[0]?.quantity?.quantity > 0">
								<div id="div_shipto" class="shipping_info">
									<div class="pane round-box" v-if="vadd">
										<h3 class="title">
											<span class="icon icon-two">{{ user.isSubChildUser ? 2 : 3 }}</span>
											DEIVERY ADDRESS
										</h3>
										<div
											v-if="(user.address == null && user.address == undefined) || (userAddresses.length === 1 || userAddresses.length == 0)">
											<div class="pane-inner"
												v-if="user.address !== null && user.address !== undefined">
												<div>
													<span style="display:inline-block;width:120px;">Business Name:</span>
													<span style="display:inline-block;width:120px;">{{ (selectedOption === 'no' && branchSwitchAddress) ? (branchSwitchAddress.businessName || user.accountTitle) : ((user.address && user.address.businessName) || user.accountTitle) }}</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Address Line
														1:</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ?
																branchSwitch.address.addressOne :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitch.address.addressOne :
																	(selectedparentOption === 'billInfo' ? user.address.addressOne :
																		'')
																)
															)
															: user.address.addressOne
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? branchSwitch.address.addressOne :
															user.address.addressOne }}
													</span>
												</div>
												<!-- <div>
													<span style="display:inline-block;width:120px;">Business Name:</span>
													<span style="display:inline-block;width:120px;">{{ user.accountTitle }}</span>
												</div> -->
												<div>
													<span style="display:inline-block;width:120px;">Address Line
														2</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ?
																branchSwitch.address.addressTwo :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitch.address.addressTwo :
																	(selectedparentOption === 'billInfo' ? user.address.addressTwo :
																		'')
																)
															)
															: user.address.addressTwo
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? branchSwitch.address.addressTwo :
															user.address.addressTwo }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">City/Town:</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitch.address.city :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitch.address.city :
																	(selectedparentOption === 'billInfo' ? user.address.city : '')
																)
															)
															: user.address.city
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? branchSwitch.address.city :
															user.address.city }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">County:</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitch.address.county :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitch.address.county :
																	(selectedparentOption === 'billInfo' ? user.address.county : '')
																)
															)
															: user.address.county
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? branchSwitch.address.county :
															user.address.county }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Country:</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitch.address.country
																:
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitch.address.country :
																	(selectedparentOption === 'billInfo' ? user.address.country :
																		'')
																)
															)
															: user.address.country
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? branchSwitch.address.country :
															user.address.country }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">PostCode:</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitch.address.postCode
																:
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitch.address.postCode :
																	(selectedparentOption === 'billInfo' ? user.address.postCode :
																		'')
																)
															)
															: user.address.postCode
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? branchSwitch.address.postCode :
															user.address.postCode }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Contact Name:</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitch.address.contactName :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitch.address.contactName :
																	(selectedparentOption === 'billInfo' ? user.address.contactName :
																		'')
																	)
																)
																: user.address.contactName
															}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? branchSwitch.address.contactName :
															user.address.contactName }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Mobile Number:</span>
													<span style="display:inline-block;width:140px;"
														v-if="!user.isSubChildUser">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? formatMobile(branchSwitch.address.mobileNumber)
																:
																(selectedparentOption === 'deiveryInfo' ?
																	formatMobile(branchSwitch.address.mobileNumber) :
																	(selectedparentOption === 'billInfo' ? formatMobile(user.address.mobileNumber) :
																		'')
																)
															)
															: formatMobile(user.address.mobileNumber)
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' ? formatMobile(branchSwitch.address.mobileNumber) :
															formatMobile(user.address.mobileNumber) }}
													</span>
												</div>
												<p v-if="user.isUserType === 'dentalcare'"></p>
												<p v-else-if="user.isSubChildUser"></p>
												<p v-else>Want a diffrent Address, click <a class="text-danger"
														@click="resetDelivery()">HERE</a> to
													set different </p>
											</div>
											<div class="pane-inner" v-else>
												<!-- <span class="text-danger"> No Default Delivery address found, click <a href="/user-dashboard/addresses">HERE</a> to set one </span> -->
												<span class="text-danger"> Select Delivery address </span>
												<select name="" id="" class="form-control" v-model="slAddress">
													<option v-for="subUser in subChildUser" :key="subUser._id"
														:value="subUser._id">{{ subUser.name
														}} {{ subUser.lastName }}</option>
													<!-- <option v-for="add in userAddresses" :value="add" :key="add._id">
										   {{ selectedOption === 'no' ? branchSwitch.billing.addressOne : add.addressOne }},
										   {{ selectedOption === 'no' ? branchSwitch.billing.city : add.city }},
										   {{ selectedOption === 'no' ? branchSwitch.billing.county : add.county }}
										   </option> -->
												</select>
												<h3>OR</h3>
												<p>Provide Manually</p>
												<input type="text" name="" id="" v-model="newAddress.addressOne"
													placeholder="Address Line One" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.addressTwo"
													placeholder="Address Line Two" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.city"
													placeholder="City/Town" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.county"
													placeholder="County" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.country"
													placeholder="Country" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.postCode"
													placeholder="Post Code" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.contactName"
													placeholder="Contact Name" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.mobileNumber" maxlength="11"
													@input="newAddress.mobileNumber = $event.target.value.replace(/[^0-9]/g, '').slice(0, 11)"
													placeholder="Mobile No" class="form-control">
												<button class="btn btn-success form-control" style="margin-bottom:15px;"
													@click="addDeliveryAddress">Add Delivery Address</button>
											</div>
										</div>
										<div v-else>
											<div class="pane-inner"
												v-if="user.address !== null && user.address !== undefined">
												<div>
													<span style="display:inline-block;width:120px;">Business Name:</span>
													<span style="display:inline-block;width:120px;">{{ (selectedOption === 'no' && branchSwitchAddress) ? (branchSwitchAddress.businessName || user.accountTitle) : ((user.address && user.address.businessName) || user.accountTitle) }}</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Address Line
														1:</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ?
																branchSwitchAddress.addressOne :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitchAddress.addressOne :
																	(selectedparentOption === 'billInfo' ? user.address.addressOne :
																		'')
																)
															)
															: user.address.addressOne
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															defaultBranchSwitchAddress.address.addressOne :
															user.address.addressOne }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Address Line
														2</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ?
																branchSwitchAddress.addressTwo :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitchAddress.addressTwo :
																	(selectedparentOption === 'billInfo' ? user.address.addressTwo :
																		'')
																)
															)
															: user.address.addressTwo
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															defaultBranchSwitchAddress.address.addressTwo :
															user.address.addressTwo }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">City/Town:</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitchAddress.city :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitchAddress.city :
																	(selectedparentOption === 'billInfo' ? user.address.city : '')
																)
															)
															: user.address.city
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															defaultBranchSwitchAddress.address.city : user.address.city }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">County:</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitchAddress.county :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitchAddress.county :
																	(selectedparentOption === 'billInfo' ? user.address.county : '')
																)
															)
															: user.address.county
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															defaultBranchSwitchAddress.address.county : user.address.county
														}}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Country:</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitchAddress.country :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitchAddress.country :
																	(selectedparentOption === 'billInfo' ? user.address.country :
																		'')
																)
															)
															: user.address.country
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															defaultBranchSwitchAddress.address.country :
															user.address.country }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">PostCode:</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ? branchSwitchAddress.postCode
																:
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitchAddress.postCode :
																	(selectedparentOption === 'billInfo' ? user.address.postCode :
																		'')
																)
															)
															: user.address.postCode
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															defaultBranchSwitchAddress.address.postCode :
															user.address.postCode }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Contact Name:</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ?
																branchSwitchAddress.contactName :
																(selectedparentOption === 'deiveryInfo' ?
																	branchSwitchAddress.contactName :
																	(selectedparentOption === 'billInfo' ? user.address.contactName
																		: '')
																	)
																)
																: user.address.contactName
															}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															defaultBranchSwitchAddress.address.contactName :
															user.address.contactName }}
													</span>
												</div>
												<div>
													<span style="display:inline-block;width:120px;">Mobile
														Number:</span>
													<span style="display:inline-block;width:140px;"
														v-if="userAddresses.length > 1">
														{{ selectedOption === 'no' ?
															(selectedparentOption === 'both' ?
																formatMobile(branchSwitchAddress.mobileNumber) :
																(selectedparentOption === 'deiveryInfo' ?
																	formatMobile(branchSwitchAddress.mobileNumber) :
																	(selectedparentOption === 'billInfo' ? formatMobile(user.address.mobileNumber)
																		: '')
																)
															)
															: formatMobile(user.address.mobileNumber)
														}}
													</span>
													<span style="display:inline-block;width:140px;" v-else>
														{{ selectedOption === 'yes' && defaultBranchSwitchAddress ?
															formatMobile(defaultBranchSwitchAddress.address.mobileNumber) :
															formatMobile(user.address.mobileNumber) }}
													</span>
												</div>
												<p v-if="userAddresses.length > 1"></p>
												<p v-else-if="user.isSubChildUser"></p>
												<p v-else>Want a diffrent Address, click <a class="text-danger"
														@click="resetDelivery()">HERE</a> to
													set different </p>
											</div>
											<div class="pane-inner" v-else>
												<!-- <span class="text-danger"> No Default Delivery address found, click <a href="/user-dashboard/addresses">HERE</a> to set one </span> -->
												<span class="text-danger"> Select Delivery address </span>
												<select name="" id="" class="form-control" v-model="slAddress">
													<option v-for="subUser in subChildUser" :key="subUser._id"
														:value="subUser._id">{{ subUser.name
														}} {{ subUser.lastName }}</option>
													<!-- <option v-for="add in userAddresses" :value="add" :key="add._id">
										   {{ selectedOption === 'no' ? branchSwitch.billing.addressOne : add.addressOne }},
										   {{ selectedOption === 'no' ? branchSwitch.billing.city : add.city }},
										   {{ selectedOption === 'no' ? branchSwitch.billing.county : add.county }}
										   </option> -->
												</select>
												<h3>OR</h3>
												<p>Provide Manually</p>
												<input type="text" name="" id="" v-model="newAddress.addressOne"
													placeholder="Address Line One" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.addressTwo"
													placeholder="Address Line Two" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.city"
													placeholder="City/Town" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.county"
													placeholder="County" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.country"
													placeholder="Country" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.postCode"
													placeholder="Post Code" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.contactName"
													placeholder="Contact Name" class="form-control">
												<input type="text" name="" id="" v-model="newAddress.mobileNumber" maxlength="11"
													@input="newAddress.mobileNumber = $event.target.value.replace(/[^0-9]/g, '').slice(0, 11)"
													placeholder="Mobile No" class="form-control">
												<button class="btn btn-success form-control" style="margin-bottom:15px;"
													@click="addDeliveryAddress">Add Delivery Address</button>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- shipping_info -->
							<div id="right-pane-top" class="col-md-12 col-sm-12 col-xs-12">
								<div id="shipping_method" class="col-md-6 col-sm-12 col-xs-12" style="display: none;">
									<div class="shipment-pane">
										<div class="pane round-box">
											<h3 class="title">
												<span class="icon icon-three">{{ user.isSubChildUser ? 3 : 4 }}</span>
												Shipping method
											</h3>
											<div class="pane-inner" style="visibility: visible;">
												Select shipment
												<fieldset id="shipments">
													<input type="radio" value="cmsmart" v-model="shippingMethod"
														id="shipment_id_1" name="virtuemart_shipmentmethod_id">
													<label for="shipment_id_1"><span class="vmshipment"><span
																class="vmshipment_name">Cmsmart</span></span></label>
													<br>
													<input type="radio" v-model="shippingMethod" value="printmart"
														id="shipment_id_2" name="virtuemart_shipmentmethod_id">
													<label for="shipment_id_2"><span class="vmshipment"><span
																class="vmshipment_name">Printmart</span></span></label>
													<br>
												</fieldset>
											</div>
										</div>
									</div>
								</div>
								<!-- shipping_method -->
								<div id="payment_method" class="col-md-12 col-sm-12 col-xs-12">
									<div class="payment-pane">
										<div class="pane round-box">
											<h3 class="title"> <span class="icon icon-four">{{ user.isSubChildUser ? 3 : (userCartItems[0]?.quantity?.quantity === 0 ? 3 : 4) }}</span> Order Email
											</h3>
											<div class="pane-inner">
												Select Email to receive order notifications<br>
												optional, leaving empty will select default user email for notifications
												<select name="" id="" class="form-control" v-model="slEmail">
													<option v-for="em in user.emails" :key="em" :value="em">{{ em }}
													</option>
												</select>
											</div>
										</div>
									</div>
								</div>
								<!-- payment_method -->
								<div id="payment_method" class="col-md-12 col-sm-12 col-xs-12">
									<div class="payment-pane">
										<div class="pane round-box">
											<h3 class="title"> <span class="icon icon-four">{{ user.isSubChildUser ? 4 :
												(userCartItems[0]?.quantity?.quantity === 0 ? 4 : 5) }}</span> Payment method
											</h3>
											<div class="pane-inner">
												Select payment method
												<!-- <pre>{{ user }}</pre> -->
												<fieldset v-if="user.accountTerms > 0 && user.accountTermsActive==true" id="payments">
													<div class="paymethodbtn">
														<div class="btnlist" style="margin-bottom: 4px;">
															<input type="radio" v-model="paymentMethod" value="Credit"
																id="payment_id_1" name="virtuemart_paymentmethod_id"
																checked="checked" style="margin-top: 0px;">
															<label for="payment_id_1" style="margin-bottom: 0px;"><span class="vmpayment"><span
																class="vmpayment_name">Pay by Account</span></span></label>
														</div>
														<div class="btnlist" style="margin-bottom: 4px;">
															<input type="radio" v-model="paymentMethod" value="Card" style="margin-top: 0px;"
																id="payment_id_2" name="virtuemart_paymentmethod_id">
															<label for="payment_id_2" style="margin-bottom: 0px;"><span class="vmpayment"><span
																		class="vmpayment_name">Pay by Card</span></span></label>
														</div>
													</div>
												</fieldset>
												<fieldset v-else id="payments">
													<div class="btnlist" style="margin-bottom: 4px;">
														<input type="radio" v-model="paymentMethod" value="Card" style="margin-top: 0px;"
															id="payment_id_2" name="virtuemart_paymentmethod_id" checked="checked">
														<label for="payment_id_2" style="margin-bottom: 0px;"><span class="vmpayment"><span
																	class="vmpayment_name">Pay by Card</span></span></label>
													</div>
												</fieldset>
											</div>
										</div>
									</div>
								</div>
								<!-- payment_method -->
							</div>
						</div>
						<div class="col-md-8 col-sm-6 col-xs-12">
						</div>
						<div id="checkfull" class="col-md-8 col-sm-12 col-xs-12">
							<div class="col-md-12 col-sm-12 col-xs-12">
								<!-- render layout -->
								<fieldset class="round-box" id="cart-contents">
									<h3 class="title"><span class="icon fa fa-check"></span>ORDER REVIEWS</h3>
									<table cellspacing="0" cellpadding="0" border="0" class="cart-summary no-border">
										<tbody>
											<tr clas="top-header">
												<th align="left" class="th-name">Products Name</th>
												<!-- <th width="10%" class="th-quoteId">Quote ID No</th> -->
												<th width="10%" class="th-price">Price</th>
												<th width="15%" class="th-tax"><span class="priceColor2">Discount</span>
												</th>
												<th width="15%" class="th-quanlity">Quantity</th>
												<th width="15%" class="th-quanlity">Delivery Trunaround</th>
												<!-- <th width="15%" class="th-discount"><span class="priceColor2">Action</span></th> -->
												<th width="15%" align="left" class="th-total th-last">SubTotal</th>
											</tr>
											<tr valign="top" id="product_row_0"
												class="product-detail-row product-detail-last-row sectiontableentry1"
												v-for="(item, index) in userCartItems" :key="item._id">
												<td align="left" class="pro_name">
													<div class="row">
														<div class="product-img">
															<img class="cart-images" :src="getImageSrc(item)"
																 @error="handleImageError">
														</div>
														<div>
															
															<p class="product-name" @click="isProductDetails(item)"
																href="javascript:void()"
																style="font-size:16px;color:#566cd7;cursor:pointer;">
																{{ item.product ? item.product.productName :
																	item.quote_id.suppliersDesription
																}} <strong @click="isProductDetails(item)" style="font-size:13px;color:#566cd7;cursor:pointer;">({{ item.quote_id ? item.quote_id.quoteNumber
																	: '' }} Product Detail )</strong>
															</p>
														</div>
														<div v-if="item.artwork">
															<span><b>Do you Require an Artwork PDF Proof
																	File?</b></span>
															<br>
															<input type="radio" v-model="selectArtworkValue[index]"
																:name="'artworkStatus_' + item._id" value="Yes">
															<label>&nbsp;&nbsp;&nbsp;Yes</label>
															<br>
															<input type="radio" v-model="selectArtworkValue[index]"
																:name="'artworkStatus_' + item._id" value="No">

															<label>&nbsp;&nbsp;&nbsp;No</label>

														</div>
														<div>
															<span style="font-size: 21px;">
																<p class="cart-delete" style="color:red;cursor:pointer;"
																	title="Delete Product"
																	@click="removeCartItem(item)">
																	<i class="fa fa-times"></i>
																	<span
																		style="font-size:17px;color:red;cursor:pointer;">Remove
																		From
																		Basket</span>
																</p>
															</span>
														</div>
													</div>

													<!-- <img class="cart-images" :src="$store.state.URL+'/uploads/artworks/'+item.artwork" style="max-width:150px;" v-if="item.artwork">
										<img class="cart-images" :src="$store.state.URL+'/uploads/product/'+item.product.image" style="max-width:150px;" v-else> -->


												</td>
												<!-- <td>{{ item.quote_id ? item.quote_id.quoteNumber : '-' }}</td> -->
												<td align="left" class="base-price">
													<div class="PricebasePrice vm-display vm-price-value">
														<span class="vm-price-desc"></span>
														<span class="PricebasePrice">&euro; {{ item.product ?
															customRoundTwoDecimals(item.quantity.sellingProductPrice)
															: customRoundTwoDecimals(item.quantity.sellingProductPrice) }}</span>
													</div>
												</td>
												<td align="right" class="base-discount">
													<span class="priceColor2">
														<div class="PricetaxAmount vm-display vm-price-value">
															<span class="vm-price-desc"></span>
															<span class="PricetaxAmount"
																:class="{ 'blue-text': item.discountPCPAm + item.discountPromoCodeAm + item.spendDiscountAm > 0 }">
																&euro; {{ item.quote_id ? 'N/A' : Math.round(
																	item.discountPCPAm +
																	item.discountPromoCodeAm +
																	item.spendDiscountAm
																).toFixed(2) }}<span v-if="item?.discountPromoCode > 0"> ({{ item.discountPromoCode }}%)</span>
															</span>
														</div>
													</span>
												</td>
												<td align="left" class="product-quanlity">
													<span>{{ item.quantity.quantity }}</span>
													<!-- <input type="text" id="quantity_0" value="1" maxlength="4" size="3" name="quantity[0]" class="quantity-input js-recalculate" title="Update Quantity In Cart"> -->
												</td>
												<td align="left" class="delivery_trunaround">
													<span>{{ (item.product) ? item.product.deliveryTurnaround :
														item.quote_id.deliveryTurnaround }}</span>
												</td>
												<td align="right" id="subtotal_with_tax_0" colspan="0"
													class="sub-total td-last"><span class="line-through"
														style="color: blue;">
														&euro; {{ item.quote_id ?
															customRoundTwoDecimals(item.quantity.sellingProductPrice) :
															customRoundTwoDecimals(
																((item.quantity.sellingProductPrice))
																- (
																	item.discountPCPAm
																	+
																	item.discountPromoCodeAm
																	+
																	item.spendDiscountAm
																)) }}
													</span>
												</td>
											</tr>
											<!--Begin of SubTotal, Tax, Shipment, Coupon Discount and Total listing -->
											<!--  Total -->
											<tr class="pr-total">
												<td colspan="6">
													<table>
														<tbody>
															<tr class="first">
																<td>SubTotal:</td>
																<td class="pr-right">
																	<div
																		class="PricesalesPrice vm-display vm-price-value">
																		<span class="vm-price-desc"></span><span
																			class="PricesalesPrice">
																			&euro; {{ $LFT(total) }}
																		</span>
																	</div>
																</td>
															</tr>
															<tr> 
																<td>VAT <span v-if="vatPercentage > 0">({{ vatPercentage }}%)</span>:</td>
																<td class="pr-right"><span id="total_tax"
																		class="priceColor2">&euro; {{
																			$LFT(VAT) }}</span></td>
															</tr>
															<tr class="last">
																<td>Total:</td>
																<td class="pr-right"><strong id="bill_total"
																		style="color: blue;">&euro; {{
																			$LFT(Number(total) + Number(VAT)) }}</strong>
																</td>
															</tr>
														</tbody>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</fieldset>
								<div id="right-pane-bottom">
									<div class="customer-note">
										<p class="comment">Notes and special requests</p>
										<textarea class="inputbox" rows="1" cols="60" v-model="notes"
											name="customer_note" id="customer_note_field"></textarea>
									</div>
									<div class="row cart-bottom">
										<div class="col-sm-6 discount-code clearfix">
											<h4>Discount Codes</h4>
											<p>Do you have a promotional code?</p>
											<form action="#" method="POST" name="discount-code">
												<div class="form-group">
													<input type="text" class="form-control" v-model="PROMOCODE"
														id="discountCode" placeholder="Promo Code"
														:disabled="preferentialMessage.isDisabled"
														@input="discountCoupon = $event.target.value">
												</div>
												<button class="gbtn btn-discount" @click.prevent="checkPromo">Apply
													Coupon</button>

												<span class="text-danger" v-if="userCartItems.length > 0">
													{{ preferentialMessage.message }}
													<!-- {{ userCartItems[0].discountPCP ? 'Preferential Pricing agreements already applied on product.' : promoError }} -->
												</span>
											</form>
										</div>
										<!--Discount Code: End-->
									</div>
									<fieldset class="vm-fieldset-tos">
										<div class="checkout-button-top">
											<button class="vm-button-correct btn btn-success" @click="purchase(total, VAT)">Confirm
												Purchase</button>
											<span class="text-danger d-block" style="color: red;"
												v-if="!user.address">Please set a default
												Delivery address</span>
											<span class="text-danger d-block" style="color: red;"
												v-if="!user.billing">Please set a default
												Billing address</span>
										</div>
									</fieldset>
								</div>
								<!-- right-pane-bottom -->
							</div>
						</div>
					</div>
					<div class="onepage" v-else>
						<app-loader text="Loading your account details" />
					</div>
				</div>
			</section>
		</main>
		<!--Main index : End-->
		<footer-section></footer-section>
		<div class="modal-mask" v-if="selectedOption === 'no' && selectedparentOption == null">
			<div class="modal-wrapper">
				<div class="modal-container">
					<div class="modal-body">
						<button class="btn btn-danger close-btn" style="float:right;" @click="closeModal">
							<b>&#10006;</b>
						</button>
						<h3 class="branch-title"><span class="icon icon-one"></span>Switch To Branch/Location</h3>
						<br>
						<div class="pane-inner">
							<div id="radio_wrapper" class="radio-btn">
								<p>
									<input type="radio" name="parentoption" value="both" v-model="selectedparentOption"
										checked />Both
								</p>
								<p>
									<input type="radio" name="parentoption" value="billInfo"
										v-model="selectedparentOption" />BILLING INFO
								</p>
								<p>
									<input type="radio" name="parentoption" value="deiveryInfo"
										v-model="selectedparentOption" /> DEIVERY ADDRESS
								</p>
								<br>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isModalVisible" class="pop-up-modals">
			<div class="pop-up-modals-content">
				<p class="pop-up-modals-title"><strong>Thank You</strong></p>
				<p class="pop-up-modals-subtitle">Please Confirm Purchase</p>
				<p class="pop-up-modals-description">
					Our Artwork Team will work quickly on providing a low-resolution PDF
					Preview File of your Design Artwork for your review before sending
					the artwork to print production.
				</p>
				<p class="pop-up-modals-note">
					Please note, delivery time of your order commences from approval of
					print-ready PDF artwork file.
				</p>
				<button class="btn" style="background-color: #007bff;" @click="closeModal">Close</button>
			</div>
		</div>
		<div v-if="isProductPopup" class="productModal-overlay">
			<div class="productModal-content flex bg-white rounded-lg shadow-lg">
				<!-- Close Button -->
				<button class="productCose-btn" @click="isProductPopup = false">✖</button>
				<!-- Product Image -->
				 
				<div class="row">
					<div class="col-sm-12">
						<p style="font-size:x-large; font-weight: 600;">Product / Service Detail</p>
					</div>
					<div class="col-sm-6">
						<img :src="productImg" alt="Product Image" class="w-full h-full object-cover rounded-l-lg" />
					</div>
					<div class="col-sm-6" style="text-align: left;">
						<p><strong>Name: </strong> {{ productData.product ? productData.product.productName : productData.quote_id.suppliersDesription }} 
							{{ productData.quote_id && productData.quote_id.quoteNumber ? ' (' + productData.quote_id.quoteNumber + ')' : '' }}
						</p>

						<p v-if="productData.opData.printed"><strong>Print:</strong> {{ productData.opData.printed }} </p>
						<p v-if="productData.opData.productPaperSizeFormat"><strong>Size:</strong> {{ productData.opData.productPaperSizeFormat }} </p>
						<p v-if="productData.opData.productPaperTypeWeight"><strong>Weight:</strong> {{ productData.opData.productPaperTypeWeight }} </p>
						<p v-if="productData.opData.material"><strong>Material:</strong> {{ productData.opData.material }} </p>
						<p v-if="productData.opData.lamination"><strong>Lamination:</strong> {{ productData.opData.lamination }} </p>
						<p v-if="productData.opData.foldingOption"><strong>Folding Options:</strong> {{ productData.opData.foldingOption }} </p>
						<p v-if="productData.opData.bookletType"><strong>Booklet Type:</strong> {{ productData.opData.bookletType }} </p>
						<p v-if="productData.opData.bookletPagination"><strong>Booklet Pagination:</strong> {{ productData.opData.bookletPagination }} </p>
						<p v-if="productData.quantity.quantity"><strong>Order Quantity:</strong> {{ productData.quantity.quantity }} </p>
						<p><strong>Delivery:</strong> {{ (productData.product) ? productData.product.deliveryTurnaround : productData.quote_id.deliveryTurnaround }} </p>
					</div>
					<!-- <img :src="product.image" alt="Product Image" class="w-full h-full object-cover rounded-l-lg" /> -->
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import { getApplicablePcpDiscountPercent } from '@/utils/pcpDiscount'
import NavBarHome from "@/components/NavBarHome.vue"
import FooterSection from "@/components/FooterSection.vue"
import AppLoader from "@/components/AppLoader.vue"
import { mapState } from 'vuex'

import { loadStripe } from '@stripe/stripe-js';
import Swal from 'sweetalert2'
export default {
	components: { NavBarHome, FooterSection, AppLoader },
	data() {
		return {
			productImg: '',
			isProductPopup: false,
			productData: null,
			isModalVisible: false,
			modalTimeout: null,
			PROMOCODE: '',
			discountCoupon: '', // Store promo code for DB
			promoError: '',
			manualBilling: false,
			manualAddress: false,
			date: '',
			vbill: true,
			vadd: true,
			slEmail: "",
			slAddress: null,
			slBilling: null,
			notes: '',
			newAddress: {},
			newBilling: {},
			billingWasReset: false,
			deliveryWasReset: false,
			shippingMethod: "cmsmart",
			paymentMethod: "",
			selectedCustomer: 'default',
			addressSearch: '',
			addressLoading: false,
			selectedOption: null,
			selectedparentOption: null,
			artworkStatus: '',
			selectArtworkValue: {},
		}
	},
	// <input type="text" name="" id="" v-model="newAddress.addressOne" placeholder="Address Line One" class="form-control">
	// <input type="text" name="" id="" v-model="newAddress.addressTwo" placeholder="Address Line Two" class="form-control">
	// <input type="text" name="" id="" v-model="newAddress.city" placeholder="City/Town" class="form-control">
	// <input type="text" name="" id="" v-model="newAddress.county" placeholder="County" class="form-control">
	// <input type="text" name="" id="" v-model="newAddress.country" placeholder="Country" class="form-control">
	// <input type="text" name="" id="" v-model="newAddress.postCode" placeholder="Post Code" class="form-control">
	// <input type="text" name="" id="" v-model="newBilling.addressOne" placeholder="Address Line One" class="form-control">
	// <input type="text" name="" id="" v-model="newBilling.addressTwo" placeholder="Address Line Two" class="form-control">
	// <input type="text" name="" id="" v-model="newBilling.city" placeholder="City/Town" class="form-control">
	// <input type="text" name="" id="" v-model="newBilling.county" placeholder="County" class="form-control">
	// <input type="text" name="" id="" v-model="newBilling.country" placeholder="Country" class="form-control">
	// <input type="text" name="" id="" v-model="newBilling.postCode" placeholder="Post Code" class="form-control">
	watch: {
		slAddress(val) {
			this.newAddress.businessName = val.businessName;
			this.newAddress.addressOne = val.addressOne;
			this.newAddress.addressTwo = val.addressTwo;
			this.newAddress.city = val.city;
			this.newAddress.county = val.county;
			this.newAddress.country = val.country;
			this.newAddress.postCode = val.postCode;
			this.newAddress.contactName = val.contactName;
			this.newAddress.mobileNumber = val.mobileNumber;
			this.addDeliveryAddress()
		},
		slBilling(val) {
			this.newBilling.businessName = val.businessName || val.billBusinessName;
			this.newBilling.addressOne = val.addressOne;
			this.newBilling.addressTwo = val.addressTwo;
			this.newBilling.city = val.city;
			this.newBilling.county = val.county;
			this.newBilling.country = val.country;
			this.newBilling.postCode = val.postCode;
			this.newBilling.mobileNumber = val.mobileNumber;
			this.addBillingAddress()
		},

	user: {
    immediate: true,
    handler(newUser) {
      if (newUser && newUser.accountTerms !== undefined) {
        const accountTerms = parseInt(newUser.accountTerms) || 0;
        const isActive = newUser.accountTermsActive === true;

        this.paymentMethod = (accountTerms > 0 && isActive) ? 'Credit' : 'Card';
      }
    }
  }
	},
	computed: {
		shouldShowDiv() {
			return this.selectedCustomer !== 'default';
		},
		isAddressListMode() {
			return !!(this.user.billing) && this.userAddresses.length > 1;
		},
		// Address picker entries for Type 1 accounts: "Default" (the account's own
		// delivery address) first, then every other saved address, led by its
		// Business Name so the reseller can recognise which client they order for.
		addressOptions() {
			const toLines = (a) => {
				if (!a) return [];
				return [
					[a.addressOne, a.addressTwo].filter(Boolean).join(', '),
					[a.city, a.county, a.postCode].filter(Boolean).join(' '),
					a.country,
				].filter(Boolean);
			};
			const own = this.user.address || null;
			const ownId = own && own._id;
			const options = [{
				id: 'default',
				businessName: (own && own.businessName) || this.user.accountTitle || '',
				lines: toLines(own),
			}];
			this.userAddresses
				.filter(a => a._id !== ownId)
				.forEach(a => options.push({ id: a._id, businessName: a.businessName || '', lines: toLines(a) }));
			return options;
		},
		filteredAddressOptions() {
			const q = this.addressSearch.trim().toLowerCase();
			if (!q) return this.addressOptions;
			return this.addressOptions.filter(opt =>
				[opt.businessName, ...opt.lines].join(' ').toLowerCase().includes(q));
		},
		...mapState(['user', 'userCart', 'userCartItems', 'userPCP', 'userAddresses', 'subChildUser', 'branchSwitchYes', 'branchSwitch', 'branchSwitchAddress', 'defaultBranchSwitchAddress']),
		// ((item.product.sellingProductPrice / item.product.quantity ) * item.quantity)
		// (( ((item.product.sellingProductPrice / item.product.quantity ) * item.quantity) * item.discountPCP ) / 100 )
		// (( ((item.product.sellingProductPrice / item.product.quantity ) * item.quantity) * item.discountPromoCode ) / 100 )
		total() {
			if (this.userCartItems.length) {

				let total = 0;

				this.userCartItems.forEach(element => {
					total += element.quote_id
						? this.$roundCurrency(element.quantity.sellingProductPrice)
						: this.$calculateSubtotal(element.quantity.sellingProductPrice, [
							element.discountPCPAm,
							element.discountPromoCodeAm,
							element.spendDiscountAm,
						]);
				});

				return this.customRoundTwoDecimals(total)
			}
			return 0;
		},
		VAT() {
			if (this.userCartItems.length) {
				let total = 0;

				this.userCartItems.forEach(element => {
					const totalRoundValue = element.quote_id
						? this.$roundCurrency(element.quantity.sellingProductPrice)
						: this.$calculateSubtotal(element.quantity.sellingProductPrice, [
							element.discountPCPAm,
							element.discountPromoCodeAm,
							element.spendDiscountAm,
						]);

					let vatOrPrice = this.$getItemVatRate(element);

					let tt = this.$calculateVat(totalRoundValue, vatOrPrice);
					total += Number(tt)
				});

				return Number(total.toFixed(2))
			}
			return 0;
		},

		vatPercentage() {
			if (this.total > 0 && this.VAT > 0) {
				return this.userCartItems.length ? Number(this.$getItemVatRate(this.userCartItems[0])) : 0;
			}
			return 0;
		},

		preferentialMessage() {
			let message = '';
			let isDisabled = false;

			// Always prioritize showing promoError if it exists
			if (this.promoError) {
				message = this.promoError;
				isDisabled = false; // An error doesn't necessarily disable the input; allow retrying
				return { message, isDisabled };
			}

			// Original logic for PCP if no promoError
			if (this.userCartItems.length === 1) {
				isDisabled = this.userCartItems[0].discountPCP > 0;
				message = isDisabled ? 'Preferential Pricing agreements already applied on product.' : '';
			} else if (this.userCartItems.length > 1) {
				// Check if any item has PCP, only disable if *any* has PCP.
				// However, if the intent is to show the message if *any* has PCP and disable if *any* has PCP
				// then the loop needs to be slightly different.
				let anyItemHasPCP = false;
				for (let item of this.userCartItems) {
					if (item.discountPCP > 0) {
						anyItemHasPCP = true;
						break;
					}
				}
				isDisabled = anyItemHasPCP;
				message = anyItemHasPCP ? 'Preferential Pricing agreements already applied on product.' : '';
			}

			return { message, isDisabled };
		},
	},
	async mounted() {
		await this.$store.dispatch("getPcps")
		await this.$store.dispatch("getUser")
		setTimeout(() => {
			this.checkDiscounts()
		}, 3000);
		
		
	},
	methods: {
		isProductDetails(item) {
			this.productData = null
			this.isProductPopup = true;
			this.productImg = ''
			if(item){
				if (item.artwork) {
					this.productImg = `${this.$store.state.URL}/uploads/artworks/${item.artwork}`;
				} else if (item.product && item.product.image) {
					this.productImg = `${this.$store.state.URL}/uploads/product/${item.product.image}`;
				} else {
					this.productImg = `${this.$store.state.URL}/uploads/product/default.png`;
				}
			}
			this.productData = item;
		},
		
		async removeCartItem(item) {
			console.log("removing cart item", item)
			await this.$store.dispatch("removeCartItem", { item })
			await this.$store.dispatch("getUser")

		},
		getImageSrcold(item) {
			if (item.artwork) {
				return `${this.$store.state.URL}/uploads/artworks/${item.artwork}`;
			} else if (item.product && item.product.image) {
				return `${this.$store.state.URL}/uploads/product/${item.product.image}`;
			} else {
				return '';
			}
		},
		getImageSrc(item) {
			if (item.product && item.product.image) {
				return `${this.$store.state.URL}/uploads/product/${item.product.image}`;
			} else if (item.product && item.product.product && item.product.product.image) {
				return `${this.$store.state.URL}/uploads/product/${item.product.product.image}`;
			} else {
				return `${this.$store.state.URL}/uploads/artworks/${item.artwork}`;
			}
		},
		handleImageError(event) {
			event.target.src = '';
		},
		async selectAddress(id) {
			if (this.addressLoading || id === this.selectedCustomer) return;
			const previous = this.selectedCustomer;
			this.selectedCustomer = id;
			try {
				await this.handleOptionChange();
			} catch (error) {
				this.selectedCustomer = previous;
				Swal.fire({ icon: 'error', title: 'Could not load address', text: 'Please try again.' });
			}
		},
		async handleOptionChange() {
			if (this.isAddressListMode) {
				// Load the chosen address before switching the Billing/Delivery
				// panels to it; they read branchSwitchAddress directly and would
				// otherwise render (and place an order) against null/stale data.
				this.addressLoading = true;
				try {
					await this.switchBranchAddressNo();
				} finally {
					this.addressLoading = false;
				}
				if (this.selectedCustomer === 'default') {
					this.selectedOption = 'yes';
					this.selectedparentOption = null;
				} else {
					this.selectedOption = 'no';
					this.selectedparentOption = 'both';
				}
			} else {
				this.selectedOption = 'yes';
				this.selectedparentOption = null;
				if (this.selectedOption == 'yes') {
					this.switchBranchYes();
				} else {
					this.switchBranchNo();
				}
			}
		},
		handleRadioChange() {
			if (this.selectedOption === 'yes') {
				this.switchBranchYes();
				this.selectedparentOption = null;
			}
			else if (this.selectedOption === 'no') {
				this.switchBranchNo();
			}
		},
		closeModal() {
			this.selectedOption = 'yes';
		},
		async switchBranchYes() {
			if (this.selectedCustomer == 'default' && this.user.isParentID) {
				await this.$store.dispatch("branchSwitch", { slug: this.user.isParentID });
			} else {
				await this.$store.dispatch("branchSwitchYes");
			}
		},
		async switchBranchNo() {
			if (this.selectedCustomer == 'default') {
				await this.$store.dispatch("branchSwitchYes");
			} else {
				await this.$store.dispatch("branchSwitch", { slug: this.selectedCustomer });
			}
		},
		async switchBranchAddressNo() {
			// console.log("INNNNNNNNNNNNNNNNNNNNNNNNNN");
			if (this.selectedCustomer == 'default') {
				console.log(this.selectedCustomer, "branchSwitchAddress default", this.user._id);
				await this.$store.dispatch("defaultBranchSwitchAddress", { slug: this.user._id });
			} else {
				console.log(this.selectedCustomer, "branchSwitchAddress No");
				await this.$store.dispatch("branchSwitchAddress", { slug: this.selectedCustomer });
			}
		},
		resetBilling() {
			this.billingWasReset = true
			this.vbill = false
			this.user.billing = null
			this.manualBilling = false
			this.newBilling = {}
			setTimeout(() => {
				this.vbill = true
			}, 1000);
		},
		resetDelivery() {
			this.deliveryWasReset = true
			this.vadd = false

			this.user.address = null
			this.manualAddress = false
			this.newAddress = {}
			setTimeout(() => {
				this.vadd = true
			}, 1000);
		},
		formatMobile(value) {
			if (value === undefined || value === null) return '';
			let mob = String(value).trim();
			if (!mob.length || mob === 'undefined' || mob === 'null') return '';
			if (mob.startsWith('+') || mob.startsWith('0')) return mob;
			return '0' + mob;
		},
		async persistCheckoutDeliveryAddress(address) {
			// Save the address entered at checkout on the customer account so it
			// shows in My Account / My Addresses and on the admin Profile Details.
			try {
				let dec = await this.$store.dispatch("addAddress", { user: this.user._id, ...address });
				if (dec.status && dec.address) {
					await this.$store.dispatch("setDefaultAddress", { id: dec.address._id, user: this.user._id });
				}
			} catch (error) {
				console.log("failed to save checkout delivery address on account", error);
			}
		},
		async persistCheckoutBillingAddress(address) {
			try {
				let dec = await this.$store.dispatch("addAddress", { user: this.user._id, ...address });
				if (dec.status && dec.address) {
					await this.$store.dispatch("setDefaultBillingAddress", { id: dec.address._id, user: this.user._id });
				}
			} catch (error) {
				console.log("failed to save checkout billing address on account", error);
			}
		},
		addDeliveryAddress() {
			let errors = []
			if (this.newAddress.addressOne.length < 1) errors.push("Address Line One Is Required")
			if (this.newAddress.addressTwo.length < 1) errors.push("Address Line Two Is Required")
			if (this.newAddress.city.length < 1) errors.push("City Is Required")
			if (this.newAddress.county.length < 1) errors.push("County Is Required")
			if (this.newAddress.country.length < 1) errors.push("Country Is Required")
			if (this.newAddress.postCode.length < 1) errors.push("Post Code Is Required")
			if (errors.length) {
				alert(errors[0])
			} else {
				this.user.address = this.newAddress;
				this.manualAddress = true
				if (!this.deliveryWasReset) this.persistCheckoutDeliveryAddress({ ...this.newAddress });
				this.newAddress = {}
			}
		},
		addBillingAddress() {
			let errors = []
			if (this.newBilling.addressOne.length < 1) errors.push("Address Line One Is Required")
			if (this.newBilling.addressTwo.length < 1) errors.push("Address Line Two Is Required")
			if (this.newBilling.city.length < 1) errors.push("City Is Required")
			if (this.newBilling.county.length < 1) errors.push("County Is Required")
			if (this.newBilling.country.length < 1) errors.push("Country Is Required")
			if (this.newBilling.postCode.length < 1) errors.push("Post Code Is Required")
			if (errors.length) {
				alert(errors[0])
			} else {
				this.user.billing = this.newBilling;
				this.manualBilling = true
				if (!this.billingWasReset) this.persistCheckoutBillingAddress({ ...this.newBilling });
				this.newBilling = {}
			}
		},
		async purchase(total, vat) {
			// The chosen address is still loading; ordering now would use the previous one.
			if (this.addressLoading) return;

			if (this.user.billing && this.user.address) {


				let items = [];
				this.userCartItems.forEach((element, index) => {
					let totals = element.quote_id
						? this.$roundCurrency(element.quantity.sellingProductPrice)
						: this.$calculateSubtotal(element.quantity.sellingProductPrice, [
							element.discountPCPAm,
							element.discountPromoCodeAm,
							element.spendDiscountAm,
						]);

					let vatOrPrice = this.$getItemVatRate(element);

					let tt = this.$calculateVat(totals, vatOrPrice)

					items.push({
						id: element._id,
						discountPromoCode: element.discountPromoCode,
						discountCoupon: this.discountCoupon,
						discountPCP: element.discountPCP,
						discountPCPAm: element.discountPCPAm,
						discountPromoCodeAm: element.discountPromoCodeAm,
						spendDiscountAm: element.spendDiscountAm,
						artwork: element.artwork,
						order: true,
						artworkProofing: this.selectArtworkValue[index] ?? "noRequirement",
						supProduct: element.product ? element.product : element.quote_id,
						productPtype: element.productPrintType,
						vat: tt,
						totalPrice: totals+tt
					})

				});
				///

				if (Object.keys(this.selectArtworkValue).length != items.filter(item => item.artwork !== null).length) {
					alert('Please select ‘Yes or No’ - Do you Require an Artwork PDF Proof File')
					return;
				} else {
					if (Object.keys(this.selectArtworkValue).length == items.filter(item => item.artwork !== null).length && Object.values(this.selectArtworkValue).includes("Yes")) {
						this.isModalVisible = true;
						setTimeout(() => {
							this.isModalVisible = false;
						}, 10000);
					}
				}

				let order = {
					items,
					email: (this.slEmail.length) ? this.slEmail : this.user.email,
					// user: (this.selectedCustomer == 'default') ? this.user._id : this.selectedCustomer,
					referralCode: (this.user.referralCode) ? this.user.referralCode : '',
					notes: this.notes,
					// isSubChildID: (
					// 	this.selectedCustomer === 'default' ? '' : this.selectedCustomer === 'yes' ? this.branchSwitchYes : this.branchSwitch),
					deliveryAt: this.date,
					paymentMethod: this.paymentMethod,
					shippingMethod: this.shippingMethod,
				};

				if (this.user.isSubChildUser == true || this.selectedOption === null) {
					order.deliveryAddress = this.user.address;
					order.billingAddress = this.user.billing;
					if (this.userAddresses.length > 1) {
						order.user = this.user._id;
					}
					else {
						order.user = (this.selectedCustomer == 'default') ? this.user._id : this.selectedCustomer;
					}
				} else {
					if (this.userAddresses.length > 1) {
						order.user = this.user._id;
						order.isSubChildID = '';
						order.deliveryAddress = this.selectedOption === 'no' ?
							(this.selectedparentOption === 'both' || this.selectedparentOption === 'deiveryInfo' ? this.branchSwitchAddress :
								(this.selectedparentOption === 'billInfo' ? this.user.address : '')
							) :
							(this.selectedOption === 'yes' ? this.user.address : this.branchSwitchAddress.address);

						order.billingAddress = this.selectedOption === 'no' ?
							(this.selectedparentOption === 'both' || this.selectedparentOption === 'billInfo' ? this.branchSwitchAddress :
								(this.selectedparentOption === 'deiveryInfo' ? this.user.billing : '')
							) :
							(this.selectedOption === 'yes' ? this.user.billing : this.branchSwitch.address);
					} else {
						order.user = (this.selectedCustomer == 'default') ? this.user._id : this.selectedCustomer;
						order.isSubChildID = (this.selectedCustomer === 'default' ? '' : this.selectedCustomer === 'yes' ? this.branchSwitchYes : this.branchSwitch);
						order.deliveryAddress = this.selectedOption === 'no' ?
							(this.selectedparentOption === 'both' || this.selectedparentOption === 'deiveryInfo' ? this.branchSwitch.address :
								(this.selectedparentOption === 'billInfo' ? this.user.address : '')
							) :
							(this.selectedOption === 'yes' ? this.user.address : this.branchSwitch.address);

						order.billingAddress = this.selectedOption === 'no' ?
							(this.selectedparentOption === 'both' || this.selectedparentOption === 'billInfo' ? this.branchSwitch.address :
								(this.selectedparentOption === 'deiveryInfo' ? this.user.billing : '')
							) :
							(this.selectedOption === 'yes' ? this.user.billing : this.branchSwitch.address);

					}
				}
				// return;   
				//  console.log(order.user);
				//  return;

				 if(order.paymentMethod === "Credit") {
					let dec = await this.$store.dispatch("placeOrder", order)
					if (dec.status) {

						this.$store.dispatch("getUser")
						if (Object.keys(this.selectArtworkValue).length == items.filter(item => item.artwork !== null).length && Object.values(this.selectArtworkValue).includes("Yes")) {
							setTimeout(() => {
								// this.$router.push({ path: '/user-dashboard/jobs' })
								this.$router.push({ path: '/user-dashboard/jobs' }).then(() => {
									window.scrollTo(0, 0);
								});
							}, 10000);
						} else {
							// this.$router.push({ path: '/user-dashboard/jobs' })
							this.$router.push({ path: '/user-dashboard/jobs' }).then(() => {
								window.scrollTo(0, 0);
							});
						}

					}
				 } else if (order.paymentMethod === "Card") {
					let dec = await this.$store.dispatch("placeOrder", order)				
					
					if (dec && dec.status && dec.orderId) {
						try {
							const sessionRes = await fetch(this.$store.state.URL + '/api/create-checkout-session', {
								method: 'POST',
								headers: { 'Content-Type': 'application/json' },
								body: JSON.stringify({
									order,
									orderId: Array.isArray(dec.orderId) ? dec.orderId[0] : dec.orderId,
									orderNumber: dec.oederData ? dec.oederData.orderNumber : '',
									invoiceNumber: dec.oederData ? dec.oederData.invoiceNumber : '',
									paymentMethod: order.paymentMethod,
									userId: order.user,
									paidBy: "Checkout",
								})
							});

							const sessionData = await sessionRes.json();

							if (sessionData && sessionData.id) {
								const stripe = await loadStripe('pk_test_TbhfuPZfID2e9clbH8d43LgD00XEDiNiqn');
								await stripe.redirectToCheckout({ sessionId: sessionData.id });
							} else {
								alert(sessionData.error || 'Stripe session creation failed');
							}
						} catch (err) {
							console.error("Stripe error:", err);
							alert("Failed to initiate Stripe payment: " + err.message);
						}
					} else {
						alert((dec && dec.message) ? dec.message : 'Failed to create order');
					}
				 }

				

			}
		},
		handleQtyChange(index) {
			let num = Number(this.$store.state.userCartItems[index].quantity)
			console.log(num)
			if (num) {
				this.$store.state.userCartItems[index].price = ((this.$store.state.userCartItems[index].product.sellingProductPrice / this.$store.state.userCartItems[index].product.quantity) * num)
			}

		},
		async proceedCheckout() {
			let cartItems = [];
			this.userCartItems.forEach(element => {
				cartItems.push({
					id: element._id,
					discountPCP: element.discountPCP,
					discountPromoCode: element.discountPromoCode,
					promoCode: element.promoCode,
					quantity: Number(element.quantity),
				})
			});
			let dec = await this.$store.dispatch("updateCartItems", { items: cartItems })
		},
		async checkPromo() {
			this.promoError = ''; // Clear previous errors
			let isDiscountAppliedToAnyItem = false;

			// Reset all existing promo codes on cart items before re-checking
			this.$store.state.userCartItems.forEach(cartItem => {
				cartItem.discountPromoCode = 0;
				cartItem.promoCode = '';
				cartItem.discountPromoCodeAm = 0;
			});

			let dec = await this.$store.dispatch("checkPromo", { code: this.PROMOCODE });
			if (dec.status) {
				console.log(dec.code)
				if (moment().isBetween(dec.code.startAt, dec.code.endAt)) {
					console.log("code is in valid date range")

					// Attempt to apply discount
					if (dec.code.discountOn == 'selected') {
						if (dec.code.products && dec.code.products.length > 0) {
							this.$store.state.userCartItems.forEach((cartItem, index) => {
								// Check if the current cart item's product ID is in the promo code's selected products list
								if (cartItem.product && dec.code.products.includes(cartItem.product._id)) {
									if (!cartItem.discountPromoCode) { // Only apply if no promo discount already set for this item
										this.$store.state.userCartItems[index].discountPromoCode = dec.code.discount;
										this.$store.state.userCartItems[index].promoCode = dec.code.code;
										this.$store.state.userCartItems[index].discountPromoCodeAm = 
											(cartItem.quantity.sellingProductPrice * dec.code.discount) / 100;
										isDiscountAppliedToAnyItem = true;
									}
								}
							});
						}
					} else { // discountOn is 'all' or similar
						this.$store.state.userCartItems.forEach((cartItem, index) => {
							if (!cartItem.discountPromoCode) { // Only apply if no promo discount already set for this item
								this.$store.state.userCartItems[index].discountPromoCode = dec.code.discount;
								this.$store.state.userCartItems[index].promoCode = dec.code.code;
								this.$store.state.userCartItems[index].discountPromoCodeAm = 
									(cartItem.quantity.sellingProductPrice * dec.code.discount) / 100;
								isDiscountAppliedToAnyItem = true;
							}
						});
					}

					// After attempting to apply, check if any discount was actually applied
					if (!isDiscountAppliedToAnyItem) {
						this.promoError = "This coupon code is not applicable to any items in your cart.";
					}


				} else {
					this.promoError = "The Code is not Useful"
				}
			} else {
				this.promoError = dec.message || "Invalid coupon code.";
			}
		},
		async checkDiscounts() {
			await this.$store.dispatch("getPcps")

			this.$store.state.userCartItems.forEach((elm, index) => {
				const productId = elm.product ? elm.product._id : null
				const discountPercent = getApplicablePcpDiscountPercent(this.userPCP, productId)
				this.$store.state.userCartItems[index].discountPCP = discountPercent
				this.$store.state.userCartItems[index].discountPCPAm = discountPercent
					? ((this.$store.state.userCartItems[index].quantity.sellingProductPrice * discountPercent) / 100)
					: 0
			});
		},

		closeModal() {
			this.isModalVisible = false;
			this.$router.push({ path: '/user-dashboard/jobs' })
		},
		customRoundTwoDecimals(value) {
			const rounded = Math.round(value);
			return rounded.toFixed(2);
		}
	},
}

</script>

<style scoped>
#payment_method{
	padding-left: 0 !important;
}
.mapouter {
	position: relative;
	text-align: right;
	height: 100%;
	width: 100%;
}

.gmap_canvas {
	overflow: hidden;
	background: none !important;
	height: 100%;
	width: 100%;
}

select.customer-list {
	width: 100%;
	padding: 8px;
	background-color: #E8E8E8;
	color: #000;
	border-radius: 4px;
	outline: none;
	margin-bottom: 10px;
	font-size: 14px;
	line-height: 24px;
	font-weight: 400;
	border: 1px solid #D9D9D9;
}

select.customer-list option {
	background-color: #fff;
	border: 1px solid var(--Stroke, rgba(0, 0, 0, 0.10));
}

.addr-picker {
	margin-bottom: 10px;
}

.addr-search {
	position: relative;
	margin-bottom: 10px;
}

.addr-search .fa {
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: #9A9A9A;
	font-size: 13px;
}

.addr-search input {
	width: 100%;
	padding: 9px 12px 9px 34px;
	border: 1px solid #D9D9D9;
	border-radius: 6px;
	font-size: 14px;
	outline: none;
}

.addr-search input:focus {
	border-color: #fd5b4e;
}

.addr-list {
	display: flex;
	flex-direction: column;
	gap: 8px;
	max-height: 340px;
	overflow-y: auto;
	padding: 2px;
}

.addr-card {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	width: 100%;
	padding: 12px 14px;
	text-align: left;
	background: #fff;
	border: 1px solid #E2E2E2;
	border-radius: 8px;
	cursor: pointer;
	transition: border-color 0.15s, box-shadow 0.15s, background-color 0.15s;
}

.addr-card:hover:not(:disabled) {
	border-color: #fd5b4e;
}

.addr-card:focus-visible {
	outline: 2px solid #fd5b4e;
	outline-offset: 1px;
}

.addr-card.is-active {
	border-color: #fd5b4e;
	background-color: #FFF5F4;
	box-shadow: 0 0 0 1px #fd5b4e;
}

.addr-picker.is-loading .addr-card {
	cursor: progress;
	opacity: 0.7;
}

.addr-check {
	flex-shrink: 0;
	width: 18px;
	height: 18px;
	margin-top: 2px;
	border: 2px solid #BDBDBD;
	border-radius: 50%;
	position: relative;
}

.addr-card.is-active .addr-check {
	border-color: #fd5b4e;
}

.addr-card.is-active .addr-check::after {
	content: '';
	position: absolute;
	inset: 3px;
	border-radius: 50%;
	background: #fd5b4e;
}

.addr-body {
	display: flex;
	flex-direction: column;
	min-width: 0;
	overflow-wrap: anywhere;
}

.addr-name {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	font-size: 14px;
	font-weight: 700;
	color: #222;
	margin-bottom: 2px;
}

.addr-name-text {
	font-weight: 700;
}

.addr-name-text.addr-name-missing {
	font-weight: 400;
	font-style: italic;
	color: #9A9A9A;
}

.addr-badge {
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: #fd5b4e;
	border: 1px solid #fd5b4e;
	border-radius: 10px;
	padding: 0 6px;
	line-height: 16px;
}

.addr-line {
	font-size: 13px;
	line-height: 19px;
	color: #6E6E6E;
}

.addr-empty {
	margin: 0;
	padding: 12px;
	color: #6E6E6E;
	font-size: 13px;
}

div.radio-btn {
	display: flex;
	gap: 20px;
}

div.radio-btn p {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	font-weight: 400;
}

div.radio-btn p>input {
	margin-top: 0;
	width: 20px;
	height: 20px;
}

.modal-mask {
	position: fixed;
	z-index: 999899989998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	max-width: 385px;
	margin-left: auto;
	margin-right: auto;
	/* margin: 0px auto; */
	padding: 1px 0px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 0px 0;
}

.modal-default-button {
	float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.close-btn {
	padding: 3px 7px;
	font-size: 12px;
	line-height: 1.5;
	border-radius: 3px;
}

.branch-title {
	font-size: 16px;
	font-weight: 700;
}

.blue-text {
	color: blue;
}

.pop-up-modals {
	z-index: 66666;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255);
	/* Semi-transparent background */
	display: flex;
	justify-content: center;
	align-items: center;
}

.pop-up-modals-content {
	background-color: #fff;
	padding: 20px 40px;
	text-align: center;
	border: 3px solid #686666;
	/* Border to match the image */
	border-radius: 8px;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
	width: 58%;
	/* Width similar to the image */
	font-family: Arial, sans-serif;
	/* Font similar to the example */
}

.pop-up-modals-title {
	font-size: 28px;
	/* Bold and larger size for the title */
	font-weight: bold;
	margin-bottom: -8px;
	color: #b6a264;
	/* Gold-like color from the image */
}

.pop-up-modals-subtitle {
	font-size: 28px;
	font-weight: bold;
	margin-bottom: 30px;
	color: #b6a264;
	/* Gold-like color */
}

.pop-up-modals-description {
	font-size: 23px;
	font-weight: bold;
	margin-bottom: 10px;
	color: #b6a264;
	/* Default text color */
}

.pop-up-modals-note {
	font-size: 18px;
	color: #b6a264;
	/* Muted gray for the note */
}

.productModal-overlay {
	position: fixed;
	top: 0px;
    z-index: 11111;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.productModal-content {
	background: white;
    padding: 20px;
    border-radius: 10px;
    border: #000000;
    width: 60%;
    text-align: center;
    position: relative;
    border-style: solid;
}

.productCose-btn {
	position: absolute;
	top: 10px;
	right: 10px;
	border: none;
	background: transparent;
	font-size: 18px;
	cursor: pointer;
}
.productModal-content p strong:first-child {
    max-width: 150px;
    width: 100%;
    display: inline-block;
}
.btnlist {
    display: flex;
    gap: 10px;
}
#customer_note_field{
	width: 100%;
}
@media (max-width: 767px) {
	.pane-inner{
		padding-bottom: 14px;
	}
}
@media (max-width: 500px) {
    .cart-summary.no-border tr.product-detail-row td.pro_name
 {
        padding-left: 21px !important;
        height: 200px !important;
    }
	button.vm-button-correct.btn.btn-success, button.gbtn.btn-discount {
		max-width: 100%;
		width: 100%;
	}
	fieldset.vm-fieldset-tos {
		padding-top: 0;
	}
}


/* 2 Sept 2025 */

.acc-info-content{
	padding: 5px;
	display: flex;
	flex-direction: column;
	gap:8px;
}
.onepage .pane-inner{
	display: flex;
	flex-direction: column;
	gap:8px;
	padding:10px;
}
.product-img{
	max-height: 200px;
	height:100%;
	max-width: 100%;
	width: 100%;
	aspect-ratio: 1;
}
.product-img img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.cart-summary.no-border tr.product-detail-row td.pro_name .row{
	max-width: 100%;
	width: 100%;
	margin: 0;
}

@media(max-width:500px){
	.cart-summary.no-border tr.product-detail-row td.pro_name .row{
		height: 100%;
	}
	.cart-summary.no-border tr.product-detail-row td.pro_name .row div.product-img{
		height: 100%;
	}
	.cart-summary.no-border tr.product-detail-row td.pro_name .row img{
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.cart-summary.no-border tr.product-detail-row td.pro_name{
		height: 100%!important;
	}
}


</style>